<template>
  <div class="image" :style="`height: ${size}px; width: ${size}px;`">
    <ImageView
      :src="src"
      ratio="1by1"
      rounded
      :style="`height: ${size}px; width: ${size}px; min-width: ${size}px;`"
      :custom-class="customClass"
    />
  </div>
</template>

<script>
import ImageView from '@/modules/core/ui/components/wrappers/ImageView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'Avatar',
  components: { ImageView },
  props: {
    src: { type: String, required: true },
    size: { type: String, default: '32' },
    customClass: { type: String }
  }
};
</script>
